import { useContext, useEffect, useState } from 'react';
import { ApiContext } from '@api/api';
import { ExternalOrdersApiTypeEnum, GetExternalOrdersResponse } from '@api/ringil-api.v2';
import { isNotNullOrUndefined } from '@utils/utils';
import { isExternalIdPresent } from '@components/framework/orders/common.tsx';

// Single source of the SN PAP rules, shared by create (form-value driven) and the detail sidebar (prop driven)
// so the two can't drift.

// PAP picker is active only for NOTINO_PAP companies with the supplier + customer location known.
export const isSnPapEnabled = (apiType?: ExternalOrdersApiTypeEnum, companyId?: string, supplierId?: string, customerLocationId?: string): boolean =>
  apiType === ExternalOrdersApiTypeEnum.NOTINO_PAP && isNotNullOrUndefined(companyId) && isNotNullOrUndefined(supplierId) && isNotNullOrUndefined(customerLocationId);

// The picker is linkable only when the integration AND this location are mapped upstream. Delegates to the shared rule.
export const snExternalIdPresent = (response?: GetExternalOrdersResponse): boolean => isExternalIdPresent(response);

// Prop-driven flavour (detail sidebar): fetches the upstream picker list when PAP is enabled.
export const useSnExternalOrders = (apiType?: ExternalOrdersApiTypeEnum, companyId?: string, supplierId?: string, customerLocationId?: string) => {
  const { getExternalOrdersByModule } = useContext(ApiContext);
  const [response, setResponse] = useState<GetExternalOrdersResponse>();

  useEffect(() => {
    if (isSnPapEnabled(apiType, companyId, supplierId, customerLocationId)) {
      getExternalOrdersByModule('SUPPLIER_NOTIFICATION', companyId, supplierId, customerLocationId, d => setResponse(d));
    } else {
      setResponse(undefined);
    }
  }, [apiType, companyId, supplierId, customerLocationId]);

  return { externalOrders: response?.orders, externalIdPresent: snExternalIdPresent(response) };
};
